import * as conversation from './conversation'
import * as trigger from './trigger'
import * as workflow from './workflow'
import * as event from './event'
import * as actions from './actions'
import * as plugins from '../plugins'

export const handlers = {
  conversation,
  trigger,
  workflow,
  event,
  actions,
  plugins,
}
